import { Input, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';
import { Canale, Categoria, Ondemand, OndemandHome, User } from '../../shared/interfacce.model';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-on-demand',
  templateUrl: './on-demand.component.html',
  styleUrls: ['./on-demand.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class OnDemandComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router, private storageService: StorageService) { }

  @Input() abbonamentoScaduto: boolean = false;

  loading: boolean = true;

  ondemands_filtrati: OndemandHome[] = [];
  ondemands: Ondemand[] = [];

  canali: Canale[] = [];
  categorie: Categoria[] = [];

  num_ondemands: number = 15;

  titoloFilter = new FormControl('');
  canaleFilter = new FormControl("-1");
  categoriaFilter = new FormControl("-1");

  user?: User;

  ngOnInit(): void {

    // Recupero l'utente loggato
    this.user = this.storageService.getUser();

    // Recupero i video ondemand
    this.apiService.getOndemandsCategorie().subscribe({
      next: (data) => {
        [...data.filter(ondemand => ondemand.video.filter(video => video.cloudflare_mp4_url != null).map(ondemand => this.ondemands.push(ondemand)))]
        this.ondemands_filtrati = data.filter(ondemand => ondemand.video.filter(video => video.cloudflare_mp4_url != null));
      },
      error: (err) => {
        this.loading = false;
        this.apiService.error("<p><strong>I video Ondemand non sono stati caricati correttamente! </strong></p> <p>Ricaricare la pagina oppure aspettare qualche secondo. </p><p>In caso di errore continuo contattaci a <strong><a href='mailto:webtv@7live.tv'>webtv@7live.tv</a></strong>!</p>")
      },
      complete: () => {

        this.loading = false;
      }
    })

  }

  onOndemand(id: number) {
    this.router.navigate(['/ondemand/' + btoa("id_ondemand=" + id)]);
  }

  onMostra(num: number) {
    this.num_ondemands += num;
  }

  onClearFiltri() {
    this.canaleFilter.setValue('-1');
    this.categoriaFilter.setValue('-1')
    this.titoloFilter.setValue('');
  }

  onFiltro() {    

    // Recupero i dati dentro ai filtri    
    let titolo = this.titoloFilter.value ? this.titoloFilter.value.toLowerCase() : '';

    // Filtro gli ondemand in base ai filtri inseriti    
    this.ondemands_filtrati.map(ondemand => {

      ondemand.video = this.ondemands.filter(video => +video.id_categoria == ondemand.id_categoria && video.titolo.toLowerCase().indexOf(titolo) >= 0)
      return ondemand;

    })    
    
  }

  checkOndemands() {
    return this.ondemands_filtrati.filter(ondemand => ondemand.video.length > 0).length <= 0;
  }

}